import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import styled from '@emotion/styled';
import 'react';
import '@teko-builder/types/pb';
import '@teko-builder/icons';
import { g as getImageUrlFromGoogleUserContent } from './image-1466e3c0.js';
import { unitParse } from './utils.es.js';
import { Link } from './components/shared/Link.es.js';

const fallbackImage = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjEzNCIgdmlld0JveD0iMCAwIDIwMCAxMzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMTMzLjMzMyIgZmlsbD0iI0VDRUNFQyIvPgo8cGF0aCBkPSJNMTAzLjUgNjNIOTYuNUM5Ni4yIDYzIDk2IDYzLjIgOTYgNjMuNVY3MC41Qzk2IDcwLjggOTYuMiA3MSA5Ni41IDcxSDEwMy41QzEwMy44IDcxIDEwNCA3MC44IDEwNCA3MC41VjYzLjVDMTA0IDYzLjIgMTAzLjggNjMgMTAzLjUgNjNaTTk5IDY1Qzk5LjMgNjUgOTkuNSA2NS4yIDk5LjUgNjUuNUM5OS41IDY1LjggOTkuMyA2NiA5OSA2NkM5OC43IDY2IDk4LjUgNjUuOCA5OC41IDY1LjVDOTguNSA2NS4yIDk4LjcgNjUgOTkgNjVaTTk3LjUgNjlMOTguNSA2N0w5OS41IDY4TDEwMSA2NkwxMDIuNSA2OUg5Ny41WiIgZmlsbD0iI0M3QzhDQSIvPgo8L3N2Zz4K';
const DsImage = (_a) => {
    var { src, height, objectFit, width, alt, onClick, borderRadius, thumbnail, hover, decoding = 'async', className, lazy = true, link, event } = _a, others = __rest(_a, ["src", "height", "objectFit", "width", "alt", "onClick", "borderRadius", "thumbnail", "hover", "decoding", "className", "lazy", "link", "event"]);
    const newSrc = getImageUrlFromGoogleUserContent(src, {
        format: 'webp',
        width: typeof width === 'number' ? width : undefined,
    });
    return (jsx(Container, Object.assign({ height: height, width: width, onClick: onClick, borderRadius: borderRadius, thumbnail: thumbnail, className: className }, others, { children: jsx(Link, Object.assign({}, link, event, { children: jsx(StyledImage, { objectFit: objectFit, src: newSrc || fallbackImage, loading: lazy ? 'lazy' : 'eager', hover: hover, decoding: decoding, alt: alt }) })) })));
};
const Container = styled.div(({ onClick, borderRadius, height, thumbnail, width }) => `
  position: relative;
  display: inline-block;
  overflow: hidden;
  ${onClick ? 'cursor: pointer;' : ''}
  ${borderRadius ? `border-radius: ${unitParse(borderRadius)};` : ''}
  ${height ? `height: ${unitParse(height)};` : ''}
  ${width ? `width: ${unitParse(width)};` : ''}
  ${thumbnail
    ? ` background-image: ${`url("${thumbnail}")`};
     background-size: cover;`
    : ''}
`);
const StyledImage = styled.img(({ hover, objectFit }) => `
  width: 100%;
  height: 100%;
  display: block;
  margin: 0 auto;
  ${objectFit ? `object-fit: ${objectFit}` : ''};
  transition: transform 0.3s;
  &:hover {
    ${hover === 'zoom' ? 'transform: scale(1.05)' : ''};
  };
`);

export { DsImage as D };
